import {
	Box,
	Chip,
	FormControl,
	InputLabel,
	MenuItem,
	OutlinedInput,
	Select,
} from "@mui/material";
import { Dispatch, SetStateAction } from "react";

type MultipleOrganSelectorProps = {
	allOrgans: string[];
	selectedOrgans: string[];
	setSelectedOrgans: Dispatch<SetStateAction<string[]>>;
};

export const MultipleOrganSelector = ({
	allOrgans,
	selectedOrgans,
	setSelectedOrgans,
}: MultipleOrganSelectorProps) => (
	<FormControl variant="outlined" sx={{ minWidth: 240 }}>
		<InputLabel>Organs</InputLabel>
		<Select
			multiple
			value={selectedOrgans}
			onChange={(e) => setSelectedOrgans(e.target.value as string[])}
			input={<OutlinedInput label="Organs" />}
			renderValue={(selected) => (
				<Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
					{(selected as string[]).map((value) => (
						<Chip key={value} label={value} style={{ margin: "2px" }} />
					))}
				</Box>
			)}
		>
			{allOrgans.map((name) => (
				<MenuItem key={name} value={name}>
					{name}
				</MenuItem>
			))}
		</Select>
	</FormControl>
);
